module.exports = __webpack_public_path__ + "img/stt-not-found-illustration.b11322b3.svg";